import * as e from "react";
import { useCallback as t, useEffect as n, useMemo as r, useRef as i, useState as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { FlexBox as c, Spinner as l, Text as u } from "@dixa/lib-shared-habla";
//#region \0rolldown/runtime.js
var d = Object.create, f = Object.defineProperty, p = Object.getOwnPropertyDescriptor, m = Object.getOwnPropertyNames, h = Object.getPrototypeOf, g = Object.prototype.hasOwnProperty, _ = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), v = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = m(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !g.call(e, s) && s !== n && f(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = p(t, s)) || r.enumerable
	});
	return e;
}, y = (e, t, n) => (n = e == null ? {} : d(h(e)), v(t || !e || !e.__esModule ? f(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region ../utils/src/components/loading.tsx
function b(e) {
	let { width: t = "100%", height: n = "100%", size: r = 56, ...i } = e;
	return /* @__PURE__ */ s(c, {
		style: {
			width: t,
			height: n,
			display: "inline-flex"
		},
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		background: "neutral.000",
		children: [/* @__PURE__ */ o(l, {
			...i,
			size: r
		}), e.text && /* @__PURE__ */ o(u.Paragraph, {
			padding: "300",
			children: e.text
		})]
	});
}
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/serialize.js
function x(e, t) {
	if (e == null) return e;
	if (e.length === 0 && (!t || t && e !== "")) return null;
	let n = e instanceof Array ? e[0] : e;
	return n == null ? n : !t && n === "" ? null : n;
}
function ee(e) {
	return e == null ? e : String(e);
}
function S(e) {
	let t = x(e, !0);
	return t == null ? t : String(t);
}
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/params.js
var C = {
	encode: ee,
	decode: S
};
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/objectToSearchString.js
function w(e) {
	let t = new URLSearchParams(), n = Object.entries(e);
	for (let [e, r] of n) if (r != null) if (Array.isArray(r)) for (let n of r) t.append(e, n ?? "");
	else t.append(e, r);
	return t.toString();
}
"{}[],\":".split("").map((e) => [e, encodeURIComponent(e)]);
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/encodeQueryParams.js
function T(e, t) {
	let n = {}, r = Object.keys(t);
	for (let i of r) {
		let r = t[i];
		e[i] ? n[i] = e[i].encode(t[i]) : n[i] = r == null ? r : String(r);
	}
	return n;
}
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/searchStringToObject.js
function E(e) {
	let t = new URLSearchParams(e), n = {};
	for (let [e, r] of t) Object.prototype.hasOwnProperty.call(n, e) ? Array.isArray(n[e]) ? n[e].push(r) : n[e] = [n[e], r] : n[e] = r;
	return n;
}
var D = new class {
	constructor() {
		this.paramsMap = /* @__PURE__ */ new Map(), this.registeredParams = /* @__PURE__ */ new Map();
	}
	set(e, t, n, r) {
		this.paramsMap.set(e, {
			stringified: t,
			decoded: n,
			decode: r
		});
	}
	has(e, t, n) {
		if (!this.paramsMap.has(e)) return !1;
		let r = this.paramsMap.get(e);
		return r ? r.stringified === t && (n == null || r.decode === n) : !1;
	}
	get(e) {
		if (this.paramsMap.has(e)) return this.paramsMap.get(e)?.decoded;
	}
	registerParams(e) {
		for (let t of e) {
			let e = this.registeredParams.get(t) || 0;
			this.registeredParams.set(t, e + 1);
		}
	}
	unregisterParams(e) {
		for (let t of e) {
			let e = (this.registeredParams.get(t) || 0) - 1;
			e <= 0 ? (this.registeredParams.delete(t), this.paramsMap.has(t) && this.paramsMap.delete(t)) : this.registeredParams.set(t, e);
		}
	}
	clear() {
		this.paramsMap.clear(), this.registeredParams.clear();
	}
}();
//#endregion
//#region ../../../node_modules/use-query-params/dist/inheritedParams.js
function O(e, t) {
	let n = {}, r = !1, i = Object.keys(e), a = i;
	if (t.includeKnownParams || t.includeKnownParams !== !1 && i.length === 0) {
		let e = Object.keys(t.params ?? {});
		a.push(...e);
	}
	for (let i of a) {
		let a = e[i];
		if (typeof a == "object" && a) {
			n[i] = a;
			continue;
		}
		r = !0, n[i] = t.params?.[i] ?? C;
	}
	return r ? n : e;
}
function k(e, t, n, r) {
	if (!n || !t.length) return e;
	let i = { ...e }, a = !1;
	for (let e of t) Object.prototype.hasOwnProperty.call(i, e) || (i[e] = n[e] ?? r, a = !0);
	return a ? i : e;
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/shallowEqual.js
var A = Object.prototype.hasOwnProperty;
function j(e, t) {
	return e === t ? e !== 0 || t !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function M(e, t, n) {
	if (j(e, t)) return !0;
	if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
	let r = Object.keys(e), i = Object.keys(t);
	if (r.length !== i.length) return !1;
	for (let i = 0; i < r.length; i++) {
		let a = n?.[r[i]]?.equals ?? j;
		if (!A.call(t, r[i]) || !a(e[r[i]], t[r[i]])) return !1;
	}
	return !0;
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/latestValues.js
function N(e, t, n) {
	let r = {}, i = Object.keys(t);
	for (let a of i) {
		let i = t[a], o = e[a], s;
		if (n.has(a, o, i.decode)) s = n.get(a);
		else {
			if (s = i.decode(o), i.equals && n.has(a, o)) {
				let e = n.get(a);
				i.equals(s, e) && (s = e);
			}
			s !== void 0 && n.set(a, o, s, i.decode);
		}
		s === void 0 && i.default !== void 0 && (s = i.default), r[a] = s;
	}
	return r;
}
function P() {
	let e;
	function t(t, n, r) {
		let i = N(t, n, r);
		return e != null && M(e, i) ? e : (e = i, i);
	}
	return t;
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/urlName.js
function F(e) {
	let t;
	for (let n in e) if (e[n].urlName) {
		let r = `${e[n].urlName}\0${n}`;
		t ? t.push(r) : t = [r];
	}
	return t ? t.join("\n") : void 0;
}
function I(e) {
	if (e) return Object.fromEntries(e.split("\n").map((e) => e.split("\0")));
}
function L(e, t) {
	let n = {};
	for (let r in e) t[r]?.urlName == null ? n[r] = e[r] : n[t[r].urlName] = e[r];
	return n;
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/memoSearchStringToObject.js
var R, z, B, V = {}, H = (e, t, n) => {
	if (R === t && B === e && z === n) return V;
	R = t, B = e;
	let r = e(t ?? "");
	z = n;
	let i = I(n);
	for (let [e, t] of Object.entries(r)) {
		i?.[e] && (delete r[e], e = i[e], r[e] = t);
		let n = V[e];
		M(t, n) && (r[e] = n);
	}
	return V = r, r;
}, U = {
	searchStringToObject: E,
	objectToSearchString: w,
	updateType: "pushIn",
	includeKnownParams: void 0,
	includeAllParams: !1,
	removeDefaultsFromUrl: !1,
	enableBatching: !1,
	skipUpdateWhenNoChange: !0
};
function W(e, t) {
	t ??= {};
	let n = {
		...e,
		...t
	};
	return t.params && e.params && (n.params = {
		...e.params,
		...t.params
	}), n;
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/QueryParamProvider.js
var G = {
	adapter: {},
	options: U
}, K = e.createContext(G);
function q() {
	let t = e.useContext(K);
	if (t === void 0 || t === G) throw Error("useQueryParams must be used within a QueryParamProvider");
	return t;
}
function J({ children: t, adapter: n, options: r }) {
	let { adapter: i, options: a } = e.useContext(K), o = e.useMemo(() => ({
		adapter: n ?? i,
		options: W(a, r)
	}), [
		n,
		r,
		i,
		a
	]);
	return /* @__PURE__ */ e.createElement(K.Provider, { value: o }, t);
}
function Y({ children: t, adapter: n, options: r }) {
	let i = n;
	return i ? /* @__PURE__ */ e.createElement(i, null, (n) => /* @__PURE__ */ e.createElement(J, {
		adapter: n,
		options: r
	}, t)) : /* @__PURE__ */ e.createElement(J, { options: r }, t);
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/removeDefaults.js
function X(e, t) {
	for (let n in e) t[n]?.default !== void 0 && e[n] !== void 0 && t[n].encode(t[n].default) === e[n] && (e[n] = void 0);
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/updateSearchString.js
function Z({ changes: e, updateType: t, currentSearchString: n, paramConfigMap: r, options: i }) {
	let { searchStringToObject: a, objectToSearchString: o } = i;
	t ??= i.updateType;
	let s, c = H(a, n), l = k(r, Object.keys(e), i.params), u;
	u = typeof e == "function" ? e(N(c, l, D)) : e, s = T(l, u), i.removeDefaultsFromUrl && X(s, l), s = L(s, l);
	let d;
	return d = o(t === "push" || t === "replace" ? s : {
		...c,
		...s
	}), d?.length && d[0] !== "?" && (d = `?${d}`), d ?? "";
}
function Q({ searchString: e, adapter: t, navigate: n, updateType: r }) {
	let i = {
		...t.location,
		search: e
	};
	n && (typeof r == "string" && r.startsWith("replace") ? t.replace(i) : t.push(i));
}
var te = (e) => e(), ne = (e) => setTimeout(() => e(), 0), $ = [];
function re(e, { immediate: t } = {}) {
	$.push(e);
	let n = t ? te : ne;
	$.length === 1 && n(() => {
		let t = $.slice();
		$.length = 0;
		let n = t[0].currentSearchString, r;
		for (let e = 0; e < t.length; ++e) r = Z(e === 0 ? t[e] : {
			...t[e],
			currentSearchString: r
		});
		e.options.skipUpdateWhenNoChange && r === n || Q({
			searchString: r ?? "",
			adapter: t[t.length - 1].adapter,
			navigate: !0,
			updateType: t[t.length - 1].updateType
		});
	});
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/useQueryParams.js
function ie(e, t) {
	let { adapter: o, options: s } = q(), [c] = a(P), { paramConfigMap: l, options: u } = oe(e, t), d = r(() => W(s, u), [s, u]), f = O(l, d), p = H(d.searchStringToObject, o.location.search, F(f));
	d.includeAllParams && (f = k(f, Object.keys(p), d.params, C));
	let m = c(p, f, D), h = Object.keys(f).join("\0");
	n(() => {
		let e = h.split("\0");
		return D.registerParams(e), () => {
			D.unregisterParams(e);
		};
	}, [h]);
	let g = {
		adapter: o,
		paramConfigMap: f,
		options: d
	}, _ = i(g);
	_.current ??= g, n(() => {
		_.current.adapter = o, _.current.paramConfigMap = f, _.current.options = d;
	}, [
		o,
		f,
		d
	]);
	let [v] = a(() => (e, t) => {
		let { adapter: n, paramConfigMap: r, options: i } = _.current;
		t ??= i.updateType, re({
			changes: e,
			updateType: t,
			currentSearchString: n.location.search,
			paramConfigMap: r,
			options: i,
			adapter: n
		}, { immediate: !i.enableBatching });
	});
	return [m, v];
}
var ae = ie;
function oe(e, t) {
	let n, r;
	return e === void 0 ? (n = {}, r = t) : Array.isArray(e) ? (n = Object.fromEntries(e.map((e) => [e, "inherit"])), r = t) : (n = e, r = t), {
		paramConfigMap: n,
		options: r
	};
}
//#endregion
//#region ../../../node_modules/use-query-params/dist/useQueryParam.js
var se = (e, n, i) => {
	let [a, o] = ae(r(() => ({ [e]: n ?? "inherit" }), [e, n]), i);
	return [a[e], t((t, n) => o(typeof t == "function" ? (n) => {
		let r = t(n[e]);
		return { [e]: r };
	} : { [e]: t }, n), [e, o])];
};
//#endregion
export { b as a, C as i, Y as n, _ as o, w as r, y as s, se as t };

//# sourceMappingURL=dist-C5MhUQHh.js.map